import { useContext } from 'react';

import i18nContext from '../components/i18n/i18nContext';
import { filterNodesByLangcode } from '@helpers/languages';

export function useMessageBanner() {
  const { lng } = useContext(i18nContext);
  const allData = {
    allBlockContentMessageBanner: {
      nodes: [
        {
          field_title: null,
          field_description:
            'Get unlimited charging for three years with Electrify America.',
          field_cta: {
            title: 'Reserve now.',
            uri: 'internal:/air/reserve',
          },
          field_open_in_new_tab_: false,
          field_visible_: false,
          langcode: 'en',
        },
        {
          field_title: '$LCID now trading on Nasdaq.',
          field_description: 'A note from our CEO on the dream ahead.',
          field_cta: {
            title: 'See more',
            uri: 'internal:/stories',
          },
          field_open_in_new_tab_: false,
          field_visible_: false,
          langcode: 'ar',
        },
        {
          field_title: 'DreamDrive has arrived.',
          field_description:
            'Catch the reveal of our intuitive ADAS technology.',
          field_cta: {
            title: 'See more',
            uri: 'internal:/en-ca/stories/grand-reveal-dreamdrive',
          },
          field_open_in_new_tab_: true,
          field_visible_: false,
          langcode: 'en-ca',
        },
      ],
    },
  };
  const filterByLanguage = data => {
    const nodes = data.allBlockContentMessageBanner.nodes;
    return filterNodesByLangcode(nodes, lng);
  };
  const getLastElement = data => [...data].pop();
  return getLastElement(filterByLanguage(allData));
}
